function parseUrl(url) {
    const el = document.createElement('a');
    el.href = url;
    return el;
}

export { parseUrl };